import * as services from '@owl-nest/services'

export function useCategoriesService() {
  return services.category.useCategories({ fetchOnMount: false })
}
